import { render, staticRenderFns } from "./MessagesHistory.vue?vue&type=template&id=46acdd59&scoped=true"
import script from "./MessagesHistory.vue?vue&type=script&lang=js"
export * from "./MessagesHistory.vue?vue&type=script&lang=js"
import style0 from "./MessagesHistory.vue?vue&type=style&index=0&id=46acdd59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46acdd59",
  null
  
)

export default component.exports